import { FC } from 'react';
// mui components
import { Button } from '@mui/material';
// styles
import { IPost } from '_interfaces/post.interface';
import { postCommentsAtom } from 'atoms';
import { useAtomValue } from 'jotai';
import { postItemStyles as styles } from '../../styles/styles';

interface IProps {
  handleClickOnComments: () => void;
  post: IPost;
}

const CommentsCount: FC<IProps> = ({ handleClickOnComments, post }) => {
  const comments = useAtomValue(postCommentsAtom(`${post.parentPath}/${post.id}`)) || [];
  return (
    <Button onClick={handleClickOnComments} size="small" sx={styles.postInfoBtn}>
      {`${comments.length ?? 0} comments`}
    </Button>
  );
};

export default CommentsCount;
